import { useTranslation } from '@/i18n/hook';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20gradient%20abstract%20background%20with%20floating%20shopping%20icons%20shoes%20bags%20caps%20accessories%20minimal%20artistic%20composition%20warm%20peach%20cream%20tones&width=1600&height=800&seq=final-cta-bg&orientation=landscape&nocache=true"
          alt="Explore CSSBuy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/90 to-background-50/80" />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
          {t('final.h2')}
        </h2>
        <p className="text-foreground-700 mb-8 leading-relaxed">
          {t('final.text')}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('cta.main1')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-6 py-3 bg-accent-500 text-background-50 font-medium rounded-lg hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            {t('cta.main2')}
          </a>
        </div>
      </div>
    </section>
  );
}